/* src/app/components/user-video/user-video.component.scss */
.view {
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  height: 100%;
}
h4 {
  font-size: 13pt;
  line-height: 1.15em;
  color: #eee;
}
p {
  color: #eee;
}
.view__wrapper {
  position: relative;
  background: #1d2529;
  width: 100%;
  height: 100%;
}
.overlay {
  position: absolute;
  z-index: 7;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(30, 30, 30, 0.9);
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
}
.overlay__wait {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.overlay__spinner {
  width: 28px;
  height: 28px;
  border: 3px solid rgba(255, 255, 255, 0.25);
  border-top-color: #fff;
  border-radius: 50%;
  animation: overlay-spin 0.8s linear infinite;
}
@keyframes overlay-spin {
  to {
    transform: rotate(360deg);
  }
}
.video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  position: relative;
  z-index: 1;
  pointer-events: none;
}
.video--playback {
  pointer-events: auto;
  z-index: 2;
}
.video__blank {
  display: none;
}
.instructions {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 12px;
  text-align: center;
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: center;
  align-items: center;
}
.instructions img {
  height: 50px;
}
ol {
  width: 100%;
  margin-top: 0px;
  font-size: 12px;
  color: #eee;
  text-align: left;
  display: flex;
  font-size: 11px;
  line-height: 1.3em;
  list-style: none;
}
.controls {
  display: flex;
  justify-content: center;
  gap: 12px;
  position: absolute;
  z-index: 6;
  bottom: 0px;
  left: 0px;
  margin-left: auto;
  justify-self: center;
  width: 100%;
  margin-bottom: 12px;
}
.controls--playback {
  bottom: 48px;
}
.controls .btn {
  background: rgba(30, 30, 30, 0.5);
  box-shadow: 0px 1px 1px 1px rgba(30, 30, 30, 0.25);
}
.timecode {
  display: inline-block;
  position: absolute;
  z-index: 6;
  pointer-events: none;
  padding: 6px 10px;
  color: white;
  background: rgba(30, 30, 30, 0.5);
  bottom: 52px;
  left: 12px;
  border-radius: 6px;
  font-size: 12px;
}
.timecode.duration-range {
  left: auto;
  right: 12px;
}
.ctrl-button {
  position: absolute;
  margin-top: 8px;
  margin-left: 8px;
  z-index: 5;
  background: rgba(30, 30, 30, 0.7);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.ctrl-button:hover,
.ctrl-button:focus {
  transform: scale(0.9);
}
.ctrl-button:active {
  transform: scale(0.8);
}
@media (orientation: portrait) {
  .video {
    object-fit: none !important;
  }
}
/*# sourceMappingURL=user-video.component.css.map */
